export default () => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M2 3.25h7m0 0L6.5.75M9 3.25l-2.5 2.5M10 8.75H3m0 0 2.5-2.5M3 8.75l2.5 2.5"
			stroke="#007178"
			strokeWidth="1.2"
			strokeLinejoin="round"
		/>
	</svg>
);
